import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { DashboardService } from "@/shared/api/services/dashboardService";
import { ActionType } from "@/shared/api/types";

/**
 * Global component that listens to location changes and logs them as NAVIGATION events.
 * Mount this once at the root of the application (inside the Router).
 */
const NavigationLogger = () => {
  const location = useLocation();
  const lastPath = useRef(location.pathname + location.search);
  const isInitialMount = useRef(true);

  useEffect(() => {
    const currentPath = location.pathname + location.search;
    
    // Skip initial mount to avoid duplicate logs if the page already logs its own initialization
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    if (currentPath !== lastPath.current) {
      // Small delay to allow session/auth state to stabilize, especially after magic link login
      const timer = setTimeout(() => {
        const token = localStorage.getItem('authToken');
        if (!token) return;

        // Log the navigation action
        DashboardService.logButtonAction({
          actionType: ActionType.NAVIGATION,
          actionName: `Navigate to ${currentPath}`,
          pageName: "AppShell",
          subSection: "Navigation",
        }).catch(() => {
          // Silent catch for analytics
        });
      }, 2000);
      
      lastPath.current = currentPath;
      return () => clearTimeout(timer);
    }
  }, [location]);

  return null;
};

export default NavigationLogger;
